<template>
  <div class="container">
    <!--  <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <ul class="content">
      <h2>秒秒测智能健康日历服务协议</h2>
      <li class="item" v-for="(item, i) in contents" :key="i">{{item}}</li>
    </ul>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
import NavBar from '../../components/NavBar/NavBar.vue'
export default {
  components: {
    NavBar
  },
  data () {
    return {
      contents: [
        '1. 秒秒测智能健康日历所展示的频道信息为频道内容提供方所有，其内容真实性、准确性、合法性由内容所有者负责。',
        '2. 秒秒测不就任何信息传递或传送的失误、不准确或错误，不对用户或任何其他人士负任何直接或间接的责任。在法律允许的范围内，秒秒测均不承担对用户或任何人就使用或未能使用秒秒测智能健康日历的频道内容或其它项目所引致的任何直接、间接、附带、从属、特殊、惩罚性或惩戒性的损害赔偿。',
        '3. 秒秒测对于健康日历所显示的内容会定期排查并对不准确的部分进行修改完善，但人工排查并不能保证100%的排查完整，我司不接受并且不妥协以任何形式的用词赔付要求。',
        '4. 秒秒测自有频道如秒秒测乌鸡汤部分文字来自网络，如果其中包含的信息侵犯您的版权或其他合法权益请联系秒秒测客服（EMAIL:support@miaomiaoce.com)，我们会在24小时内审核处理。'
      ]
    }
  },
  methods: {
    leftClick () {
      this.$router.back(-1)
    }
  },
  mounted () {
    Common.setTitle('服务协议')
  }
}
</script>
<style lang="stylus" scoped>
.content
  height 100%
  width 100%
  background #ffffff
  box-sizing border-box
  padding 0 20px 20px
  overflow auto
  font-size 15px
  h2
    font-size 20px
    text-align center
    line-height 60px
  .item
    color #666666
    line-height 24px
</style>


// WEBPACK FOOTER //
// src/pages/Agreement/Agreement.vue